import Marquee from "react-fast-marquee";

const WORDS = [
  "Struktur",
  "Klarheit",
  "Datenschutz",
  "Fallakte",
  "Muster",
  "Verlässlichkeit",
  "Offline First",
  "Verschlüsselung",
  "Chronologie",
  "Ruhe",
];

export default function EditorialMarquee() {
  return (
    <section
      aria-hidden
      className="relative py-24 md:py-36 border-y border-white/5 bg-[#0B1120]/60 overflow-hidden"
      data-testid="editorial-marquee"
    >
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(80% 60% at 50% 50%, rgba(0,250,248,0.05), transparent 70%)",
        }}
      />
      <Marquee gradient={false} speed={22} pauseOnHover={false} className="relative">
        {WORDS.map((w) => (
          <span
            key={w}
            className="font-display text-[80px] md:text-[140px] leading-none tracking-[-0.05em] mx-8 md:mx-14"
            style={{
              color: "transparent",
              WebkitTextStroke: "1px rgba(255,255,255,0.14)",
            }}
          >
            {w}
            <span className="text-[#00FAF8]" style={{ WebkitTextStroke: "0" }}>
              .
            </span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
